import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import {DateField} from 'components/Fields';
import FormField from 'components/FormField';
import {verifyVisa, selectBooking, selectSelectedKycId} from 'ducks/bookings';
import {validDate} from 'utils/validators';
import {formatDateForApi} from 'utils/datetime';

const formSubmit = (values, dispatch, props) => {
  const {kycId, bookingId, getExtraActions} = props;
  const extraActions = getExtraActions();

  const data = {
    kycId,
    bookingId,
    expiryDate: formatDateForApi(values.expiryDate)
  };

  dispatch(verifyVisa(data, extraActions));
};

class KycVerifyVisaForm extends React.Component<any> {
  render() {
    const {error} = this.props;

    return (
      <form>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Enter the expiry date shown on the visa documents</Label>
          <Field
            name="expiryDate"
            validate={[validDate]}
            component={DateField}
          />
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const kycId = selectSelectedKycId(state);
  const booking = selectBooking(state);
  const bookingId = _.get(booking, 'id');

  return {kycId, bookingId};
};

const mapDispatchToProps = {};

const kycVerifyVisaForm = reduxForm({
  form: 'kycVerifyVisaForm',
  onSubmit: formSubmit
})(KycVerifyVisaForm);

export default connect(mapStateToProps, mapDispatchToProps)(kycVerifyVisaForm);
